export default __webpack_public_path__ + "static/media/content-2-transparent.4f049eb0.png";